import { withPlaceholder } from '#utils/withPlaceholder'

export const Placeholder = withPlaceholder('div')
